import { motion } from "framer-motion";
import CaseCard from "../components/CaseCard";
import casesData from "../data/casesData";

export default function CaseStudies() {
  return (
    <section className="min-h-screen pt-28 pb-20 px-6 lg:px-20 max-w-7xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="mb-16"
      >
        <h1 className="text-5xl md:text-6xl font-bold">
          Our{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyber-blue to-tech-green">
            Work
          </span>
        </h1>
        <p className="text-gray-400 text-lg mt-4 max-w-2xl">
          Each project is a story — from identifying the problem to engineering
          the solution. Browse our case studies below.
        </p>
      </motion.div>

      <div className="grid md:grid-cols-2 gap-8">
        {casesData.map((c, i) => (
          <CaseCard key={c.slug} {...c} index={i} />
        ))}
      </div>
    </section>
  );
}
